import { render, staticRenderFns } from "./Settlementsdetails.vue?vue&type=template&id=c0c3ba5e&scoped=true"
import script from "./Settlementsdetails.vue?vue&type=script&lang=js"
export * from "./Settlementsdetails.vue?vue&type=script&lang=js"
import style0 from "./Settlementsdetails.vue?vue&type=style&index=0&id=c0c3ba5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c3ba5e",
  null
  
)

export default component.exports